import {
  OEText,
  PanelLayout,
  PanelSlider,
  mb,
  pl,
  pr,
  width,
} from '@openeducation/oe-it-components';
import type { FeedbackResponseDTO } from '@openeducation/oe-it-services';
import { styled } from '@openeducation/oe-it-themes';
import React from 'react';
import { View } from 'react-native';

import { PCFeedbackCardComment } from './pc-feedback-card-comment';
import { PCFeedbackCardLessonTitle } from './pc-feedback-card-lesson-title';
import { PCFeedbackCardTitle } from './pc-feedback-card-title';

export type PCFeedbackCardContentListProps = {
  feedbacks: FeedbackResponseDTO[];
};

export const PCFeedbackCard = ({
  feedbacks,
}: PCFeedbackCardContentListProps) => {
  const Content = ({ current }: { current: number }) => (
    <StyledPanelLayout
      width={feedbacks.length === 1 ? 700 : 630}
      height={267}
      opacityBackground={0.5}
      padding={30}
    >
      <PCFeedbackCardTitle feedback={feedbacks[current]} />
      <PCFeedbackCardLessonTitle lessonName={feedbacks[current].lessonName} />
      <PCFeedbackCardComment feedback={feedbacks[current]} />
    </StyledPanelLayout>
  );

  return (
    <>
      <View style={[mb(16), pl(78), pr(38), width(780)]}>
        <Heading>PREVIOUS CLASS FEEDBACK</Heading>
      </View>
      <PanelSlider size={feedbacks.length}>
        {(current) => <Content current={current} />}
      </PanelSlider>
    </>
  );
};

const StyledPanelLayout = styled(PanelLayout).attrs(({ theme }) => ({
  backgroundColor: theme.color.light1,
}))``;

const Heading = styled(OEText).attrs(({ theme }) => ({
  color: theme.color.dark3,
  fontSize: 12,
}))``;
